import { request } from '@/common'
/**
 * 保存联系人信息
 * @param {*} params
 */
export function contactSave(params: any) {
  return request.post('institutional-common', 'api/not-login/contact/save', {
    params,
  })
}
